export enum BotMode {
  AUTO_BUY = 'AUTO_BUY',
  NOTIFY_ONLY = 'NOTIFY_ONLY',
}
